import React, { Component, Fragment } from 'react';
import {
    Card,
    Form,
    Row,
    Col,
    Select,
    Input,
    Button,
    Empty,
    Divider,
    Tabs,
    Carousel,
    message
} from 'antd';
import { VersionForm } from './VersionForm';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

const Option = Select.Option;
const fileReader = new FileReader();
const TabPane = Tabs.TabPane;

@inject('store')
@observer
@withRouter
class ListingFormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            screenshots: (props.data && props.data.screenshots) || [],
            list: [],
            versions: (props.data && props.data.versions) || []
        };
    }

    handleAddVersion() {
        let next = [...this.state.versions];
        next.push({
            published: 'draft',
            version: '',
            update_notes: '',
            strategies: [],
            created_at: Date.now(),
            tags: []
        });
        this.setState({ versions: next });
    }

    async handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                values.author = this.props.store.userStore.currentUser.name;
                if (this.props.edit) {
                    try {
                        await this.props.store.stratCenter.update(this.props.match.params.id, {
                            ...values,
                            versions: this.state.versions,
                            screenshots: this.state.screenshots
                        });
                        message.success('Listing updated');
                        this.props.history.push('/a/strat-center/my-listings');
                    } catch (e) {
                        message.error(e.message);
                    }
                } else {
                    try {
                        await this.props.store.stratCenter.create({
                            ...values,
                            versions: this.state.versions,
                            screenshots: this.state.screenshots
                        });
                        this.props.history.push('/a/strat-center/my-listings');
                        message.success('Listing created');
                    } catch (e) {
                        console.log(e);
                        message.error(e.message);
                    }
                }
            }
        });
    }

    updateVersion(idx, values) {
        let next = [...this.state.versions];
        next[idx] = values;
        this.setState({ versions: next });
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        const botType = getFieldValue('bot_type');

        return (
            <Fragment>
                <Card
                    size="small"
                    title={this.props.title}
                    bordered={false}
                    style={{ marginBottom: 15 }}
                >
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="Details" key="1">
                            <Form>
                                <Row gutter={24}>
                                    <Col md={6}>
                                        <Form.Item label="Listing type">
                                            {getFieldDecorator('listing_type', {
                                                initialValue: 'strategy'
                                            })(
                                                <Select>
                                                    <Option value="strategy">Strategy</Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Item label="Bot">
                                            {getFieldDecorator('bot_type', {
                                                initialValue: 'apex'
                                            })(
                                                <Select>
                                                    <Option value="apex">Apex</Option>
                                                    <Option value="odyssey">Odyssey</Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Item label="Availability">
                                            {getFieldDecorator('availability', {
                                                initialValue: 'public'
                                            })(
                                                <Select>
                                                    <Option value="public">Public</Option>
                                                    <Option value="private">Private</Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col md={8}>
                                        <Form.Item label="Name">
                                            {getFieldDecorator('name', {
                                                rules: [
                                                    { required: true, message: 'Name is required' }
                                                ]
                                            })(<Input />)}
                                        </Form.Item>
                                    </Col>

                                    <Col md={24}>
                                        <Form.Item label="Description">
                                            {getFieldDecorator('description', {
                                                initialValue: '',
                                                rules: [
                                                    { required: true, message: 'Name is required' }
                                                ]
                                            })(<Input.TextArea rows={10} />)}
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Divider orientation={'left'}>Additional Information</Divider>

                                <Row gutter={24}>
                                    <Col md={6}>
                                        <Form.Item label="Supported Base">
                                            {getFieldDecorator('supported_base', {
                                                initialValue: 'BTC'
                                            })(
                                                <Select mode="multiple">
                                                    <Option value="BTC">BTC</Option>
                                                    <Option value="ETH">ETH</Option>
                                                    <Option value="XRP">XRP</Option>
                                                    <Option value="BNB">BNB</Option>
                                                    <Option value="USDT">USDT</Option>
                                                    <Option value="TUSD">TUSD</Option>
                                                    <Option value="PAX">PAX</Option>
                                                    <Option value="USDC">USDC</Option>
                                                    <Option value="USD">USD</Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Item label="Tags">
                                            {getFieldDecorator('tags', {})(
                                                <Select mode="multiple">
                                                    <Option value="Scalper">Scalper</Option>
                                                    <Option value="Market Maker">
                                                        Market Maker
                                                    </Option>
                                                    <Option value="Swing Trader">
                                                        Swing Trader
                                                    </Option>
                                                    <Option value="Automation">Automation</Option>
                                                    <Option value="ART">ART</Option>
                                                    <Option value="ADCA">ADCA</Option>
                                                    <Option value="SOTA">SOTA</Option>
                                                    <Option value="TSL">TSL</Option>
                                                    <Option value="PP">PP</Option>
                                                    <Option value="DPP">DPP</Option>
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </TabPane>
                        <TabPane tab="Instructions" key="2">
                            <Row gutter={24}>
                                <Col md={24}>
                                    <Form.Item label="Description">
                                        {getFieldDecorator('setup_guide', {
                                            initialValue: ''
                                        })(<Input.TextArea rows={30} />)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tab="Screenshots" key="3">
                            <Row gutter={24}>
                                <Col md={12}>
                                    <Form.Item
                                        label="Screenshots"
                                        extra={
                                            'Ensure your images are at least 1000px wide and have the same height'
                                        }
                                    >
                                        <input
                                            ref="file"
                                            type="file"
                                            name="file"
                                            className="upload-file"
                                            id="file"
                                            onChange={e => {
                                                const file = e.target.files[0];
                                                const reader = new FileReader();
                                                if (file.type === 'image/png') {
                                                    reader.readAsDataURL(file);

                                                    reader.onload = () => {
                                                        if (reader.result) {
                                                            let next = this.state.screenshots;
                                                            next.push({
                                                                src: reader.result,
                                                                name: file.name
                                                            });
                                                            this.setState({ screenshots: next });
                                                        }
                                                    };
                                                }
                                                e.target.value = '';
                                            }}
                                            encType="multipart/form-data"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={12}>
                                    {this.state.screenshots.map((file, i) => {
                                        return (
                                            <div key={i}>
                                                <img
                                                    src={file.src}
                                                    style={{ width: '60px' }}
                                                    alt="preview"
                                                />{' '}
                                                {file.name}{' '}
                                                <Button
                                                    icon={'delete'}
                                                    size={'small'}
                                                    type={'danger'}
                                                    onClick={() => {
                                                        let next = this.state.screenshots;
                                                        next.splice(i, 1);
                                                        this.setState({ screenshots: next });
                                                    }}
                                                >
                                                    Delete
                                                </Button>
                                            </div>
                                        );
                                    })}
                                </Col>
                                <Col md={24}>
                                    <Carousel autoplay arrows adaptiveHeight>
                                        {this.state.screenshots.map((file, i) => {
                                            return (
                                                <div key={i}>
                                                    <img
                                                        src={file.src}
                                                        alt="preview"
                                                        style={{ maxWidth: '100%' }}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </Carousel>
                                </Col>
                            </Row>
                        </TabPane>
                    </Tabs>
                </Card>

                <Card
                    size="small"
                    title={'Versions'}
                    bordered={false}
                    style={{ marginBottom: 15 }}
                    extra={
                        <Button type={'primary'} onClick={this.handleAddVersion.bind(this)}>
                            Add Version
                        </Button>
                    }
                >
                    {this.state.versions.length ? (
                        this.state.versions.map((version, i) => {
                            return (
                                <Card key={i} style={{ marginBottom: 10 }}>
                                    <VersionForm
                                        data={version}
                                        botType={botType}
                                        id={i + 1}
                                        onChange={this.updateVersion.bind(this, i)}
                                    />
                                </Card>
                            );
                        })
                    ) : (
                        <Empty description={'Add a version'} />
                    )}
                </Card>

                <div style={{ textAlign: 'right' }}>
                    <Button
                        disabled={!this.state.versions.length}
                        size="large"
                        type={'primary'}
                        onClick={this.handleSubmit.bind(this)}
                    >
                        Save
                    </Button>
                </div>
            </Fragment>
        );
    }

    onChange = info => {
        const nextState = { ...this.state };
        switch (info.file.status) {
            case 'uploading':
                nextState.fileList = [info.file];
                break;
            case 'done':
                console.log(info.file);
                nextState.selectedFile = info.file;

                fileReader.readAsDataURL(info.file.originFileObj);
                fileReader.onloadend = () => {
                    nextState.fileList.push({
                        uid: info.uid,
                        name: info.name,
                        status: 'done',
                        url: fileReader.result
                    });

                    nextState.list.push({
                        uid: info.uid,
                        name: info.name,
                        status: 'done',
                        url: fileReader.result
                    });
                };
                break;

            default:
                // error or removed
                nextState.selectedFile = null;
                nextState.fileList = [];
        }
        this.setState(() => nextState);
    };

    handleCancel() {
        this.setState({ previewVisible: false });
    }

    handlePreview(file) {
        console.log(file);
        this.setState({
            // previewImage: file.thumbUrl,
            previewVisible: true
        });
    }
}

export const ListingForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(key => {
            data[key] = Form.createFormField({ value: props.data[key] });
        });
        return data;
    }
})(ListingFormComponent);



// WEBPACK FOOTER //
// ./src/Account/StratCenter/Form/index.js